<div class="header">
    <div class="icon-tuteurentreprise"></div>
    <div class="label">{{ getString('title') }}</div>
    <button mat-icon-button (click)="handleCloseDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="content">
    <div class="current-related-users" [class.full-display]="data.viewOnly">
        <div class="label">{{ getString('current-related-users') }}</div>
        <div class="users-container">
            @for (relatedUser of data.relatedUsers; track relatedUser) {
                <div class="user" [class.disabled]="!relatedUser.enabled">
                    <div [ngClass]="getUserIcon(relatedUser)"></div>
                    <div class="user-name">
                        {{ relatedUser.firstname }} {{ relatedUser.lastname.toUpperCase() }}
                    </div>
                    @if (!data.viewOnly) {
                        <div class="icon-selected" (click)="unselectUser(relatedUser)"></div>
                    }
                </div>
            }
            @for (relatedGroup of data.relatedGroups; track relatedGroup) {
                <div class="user">
                    <div class="icon-groupe"></div>
                    <div class="user-name">{{ relatedGroup.name }}</div>
                    @if (!data.viewOnly) {
                        <div class="icon-selected" (click)="unselectGroup(relatedGroup)"></div>
                    }
                </div>
            }
        </div>
    </div>
    @if (!data.viewOnly) {
        <div class="possible-container">
            <div class="right-header">
                @if (data.tutor) {
                    <mat-checkbox (change)="toggleDisabledUsers()"
                        >Afficher les utilisateurs désactivés</mat-checkbox
                    >
                }

                <mat-form-field class="search-form-field">
                    <mat-label>Rechercher</mat-label>
                    <input
                        matInput
                        type="text"
                        [(ngModel)]="search"
                        (keyup.enter)="refreshData()"
                    />
                    @if (search) {
                        <button matSuffix mat-icon-button (click)="refreshData(true)">
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                    <button matSuffix mat-icon-button (click)="refreshData()">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="possible-related-users">
                <div class="label">
                    {{ getString('possible-related-users') }}
                </div>
                @if (isLoading('getUsers')) {
                    <app-loading></app-loading>
                } @else {
                    <div
                        class="users-container"
                        infiniteScroll
                        [infiniteScrollDistance]="2"
                        [infiniteScrollThrottle]="50"
                        [scrollWindow]="false"
                        (scrolled)="getUsers()"
                    >
                        @for (user of users; track user) {
                            <div class="user" [class.disabled]="!user.enabled">
                                <div [ngClass]="getUserIcon(user)"></div>
                                <div class="user-name">
                                    {{ user.firstname }} {{ user.lastname.toUpperCase() }}
                                </div>
                                <div class="icon-select" (click)="selectUser(user)"></div>
                            </div>
                        }
                        @if (isLoading('getUsersNextPage')) {
                            <div class="loading-container">
                                <app-loading></app-loading>
                            </div>
                        }
                    </div>
                }
            </div>

            <div class="possible-related-groups">
                <div class="label">{{ getString('possible-related-groups') }}</div>

                @if (isLoading('getGroups')) {
                    <app-loading></app-loading>
                } @else {
                    <div
                        class="users-container"
                        infiniteScroll
                        [infiniteScrollDistance]="2"
                        [infiniteScrollThrottle]="50"
                        [scrollWindow]="false"
                        (scrolled)="getGroups()"
                    >
                        @for (group of groups; track group) {
                            <div class="user">
                                <div class="icon-groupe"></div>
                                <div class="user-name">{{ group.name }}</div>
                                <div class="icon-select" (click)="selectGroup(group)"></div>
                            </div>
                        }
                        @if (isLoading('getGroupsNextPage')) {
                            <div class="loading-container">
                                <app-loading></app-loading>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</mat-dialog-content>
@if (!data.viewOnly) {
    <div class="footer">
        <button class="button" mat-button (click)="handleCloseDialog()">Valider</button>
    </div>
}
